import PersistenceRegistry from '../base/redux/PersistenceRegistry';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CUSTOM_PANEL_CLOSE, CUSTOM_PANEL_OPEN, SET_CUSTOM_PANEL_ENABLED, SET_CUSTOM_PANEL_IS_RESIZING, SET_CUSTOM_PANEL_WIDTH, SET_USER_CUSTOM_PANEL_WIDTH } from './actionTypes';
import { DEFAULT_CUSTOM_PANEL_WIDTH } from './constants';
const DEFAULT_STATE = {
    enabled: false,
    isOpen: false,
    isResizing: false,
    width: {
        current: DEFAULT_CUSTOM_PANEL_WIDTH,
        userSet: null
    }
};
/**
 * Persist only the width subtree so the user's preferred panel width
 * survives page reloads.
 */
// 与 side-panel 相同：局部持久化必须合并 DEFAULT_STATE，避免 rehydrate 半成品状态。
PersistenceRegistry.register('features/custom-panel', {
    enabled: true,
    width: true
}, DEFAULT_STATE);
/**
 * Listen for actions that mutate the custom panel state.
 */
ReducerRegistry.register('features/custom-panel', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CUSTOM_PANEL_CLOSE:
            return {
                ...state,
                isOpen: false
            };
        case CUSTOM_PANEL_OPEN:
            return {
                ...state,
                isOpen: true
            };
        case SET_CUSTOM_PANEL_ENABLED:
            return {
                ...state,
                enabled: action.enabled
            };
        case SET_CUSTOM_PANEL_WIDTH:
            return {
                ...state,
                width: {
                    ...state.width,
                    current: action.width
                }
            };
        case SET_USER_CUSTOM_PANEL_WIDTH:
            return {
                ...state,
                width: {
                    current: action.width,
                    userSet: action.width
                }
            };
        case SET_CUSTOM_PANEL_IS_RESIZING:
            return {
                ...state,
                isResizing: action.resizing
            };
        default:
            return state;
    }
});
